import UserAvatarPopoverContainer from './UserAvatarPopover.container';
import UserAvatarPopover from './UserAvatarPopover';
import userAvatarPopoverReducers from './reducers';
import UserAvatarPopoverButtonsContext from './UserAvatarPopoverButtonsContext';
import * as userAvatarPopoverActionCreators from './actionCreators';
import userAvatarPopoverSaga from './saga';
export default UserAvatarPopoverContainer(UserAvatarPopover);
export { userAvatarPopoverReducers, userAvatarPopoverSaga, userAvatarPopoverActionCreators, UserAvatarPopoverButtonsContext };

//# sourceMappingURL=index.js.map